import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';

import '@maersk-global/mds-components-core/mc-pagination';
import '@maersk-global/mds-components-core/mc-select';

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [],
  templateUrl: './aems-pagination.component.html',
  styleUrls: ['./aems-pagination.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PaginationComponent {
  /** Inputs coming from parent component (API-driven) */
  @Input() firstPage?: number;
  @Input() previousPage?: number;
  @Input() currentPage: number = 1;
  @Input() nextPage?: number;
  @Input() lastPage?: number;
  @Input() totalRecords: number = 0; // ✅ rename from totalItemCount
  @Input() pageLimit: number = 20;
  @Input() pageLimitOptions = [10, 20, 50, 100, 200];
  @Input() showCountOnly = false;

  /** Outputs to notify parent of user actions */
  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  /** Handle page size change */
  onPageLimitChange(event: Event & { detail?: { value?: number } }): void {
    const newSize = Number(event.detail?.value);
    if (!Number.isNaN(newSize)) {
      this.pageLimit = newSize;
      this.currentPage = 1;
      this.pageSizeChange.emit(newSize);
    }
  }

  /** Handle page change from pagination control */
  onPageChangeEvent(event: Event & { detail?: number }): void {
    const newPage = event.detail;
    if (newPage && newPage !== this.currentPage) {
      this.pageChange.emit(newPage);
    }
  }

  /** Display range info */
  get showingRange(): string {
    if (this.totalRecords === 0) return 'Showing 0 of 0';
    const start = (this.currentPage - 1) * this.pageLimit + 1;
    const end = Math.min(this.currentPage * this.pageLimit, this.totalRecords);
    if (this.showCountOnly) {
      return `Showing ${end - start + 1} of ${this.totalRecords}`;
    }
    return `Showing ${start}-${end} of ${this.totalRecords}`;
  }

  /** Whether pagination should be disabled */
  get isPaginationDisabled(): boolean {
    return !this.lastPage || this.lastPage <= 1;
  }
}
